import useSWR from 'swr';
import { SwrReturnType } from '~/models/Api';
import { DealEstimationHistoryContext } from '~/models/DealEstimationHistory';

const paths = {
  show: '/vendors/deals/:deal_id/deal_estimation_confirmed_headers/:id'
};

type TShow = (
  dealId: number | null,
  id: number | null
) => SwrReturnType<DealEstimationHistoryContext>;
type ReturnType = {
  show: TShow;
};

export const useDealEstimationConfirmedHeaders = (): ReturnType => {
  const show: TShow = (dealId: number | null, id: number | null) => {
    const { data, mutate, isLoading, error } =
      useSWR<DealEstimationHistoryContext>(
        dealId === null || id === null
          ? null
          : paths.show
              .replace(':deal_id', String(dealId))
              .replace(':id', String(id))
      );
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  return { show };
};
